<template>
  <div class="section">
    <transition appear @before-enter="beforeEnterH1" @enter="enterH1">
      <h1>{{ "" }}</h1>
    </transition>
    <transition-group
      appear
      tag="div"
      class="grid grid-3"
      @before-enter="beforeEnter"
      @enter="enter"
    >
      <div
        v-for="(lang, index) in langs"
        class="flex flex-col"
        :key="lang.lang"
        :data-index="index"
      >
        <span>{{ lang.lang }}</span>
        <div>
          <span
            :class="lang.lang.toLowerCase() + ' progress-bar'"
            :style="{ width: lang.percentage + '%' }"
          ></span>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<script>
import gsapAnimation from "../../composables/gsapAnimation";
export default {
  props: {
    langs: Array,
    beforeEnter: Function,
    enter: Function,
  },
  setup() {
    const { beforeEnterH1, enterH1 } = gsapAnimation({
      h1: "Langages",
      duration: 5,
    });
    return {
      beforeEnterH1,
      enterH1,
    };
  },
};
</script>
<style scoped>
.flex {
  align-items: flex-start;
}
.flex div {
  width: 100%;
  height: 6px;
  overflow: hidden;
  margin-top: 1rem;
  border-radius: 3px;
  position: relative;
  background: var(--secondary);
  box-shadow: 0 0 1px var(--dark) inset;
}
.arabic {
  background: var(--primary);
}
.english {
  background: var(--red);
}
.french {
  background: var(--blue);
}
.progress-bar {
  z-index: 1;
  height: 6px;
  border-radius: 2px;
  position: absolute;
  background-size: 30px 30px;
  box-shadow: 0 1px 0 #ffffff80 inset;
  transition: width 0.4s ease-in-out;
  background-image: linear-gradient(
    135deg,
    #ffffff55 25%,
    transparent 25%,
    transparent 50%,
    #ffffff55 50%,
    #ffffff55 75%,
    transparent 75%,
    transparent
  );
  animation: progressBar 3s linear infinite;
  animation-fill-mode: both;
}

@keyframes progressBar {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 60px 0;
  }
}
</style>
